import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ClientLogos from "@/components/ClientLogos";
import ProductsGrid from "@/components/ProductsGrid";
import WhyChoose from "@/components/WhyChoose";
import VideoSection from "@/components/VideoSection";
import HowItWorks from "@/components/HowItWorks";
import PriceTable from "@/components/PriceTable";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import BottomCTA from "@/components/BottomCTA";
import StickyCTAs from "@/components/StickyCTAs";
import MobileBottomBar from "@/components/MobileBottomBar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-[#fafaf9]">
      {/* Urgency Strip */}
      <div data-testid="urgency-strip" className="bg-[#b22300] text-white text-center py-2 px-4 text-xs sm:text-sm font-medium">
        Limited Period: <strong>Free Site Survey</strong> + <strong>No-Cost Installation</strong> on all Stair Lifts | <a href="tel:+919654399019" className="underline font-bold">Call Now</a>
      </div>
      <Header />
      <main>
        <Hero />
        <ClientLogos />
        <ProductsGrid />
        <WhyChoose />
        <VideoSection />
        <HowItWorks />
        <PriceTable />
        <Testimonials />
        <FAQ />
        <BottomCTA />
      </main>
      <Footer />
      <StickyCTAs />
      <MobileBottomBar />
      {/* Extra padding on mobile for bottom bar */}
      <div className="h-14 sm:hidden" />
    </div>
  );
}

export default App;
